import {Component} from "@/event/calendar/dom/Component.ts";
import type {GutterSized} from "@/event/calendar/days/GutterSized.ts";
import type {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {Rect} from "@/event/calendar/Shapes.ts";

export class DaysCorner extends Component implements GutterSized {
	public gutterWidth:number;

	constructor() {
		super();
	}

	calcMinGutter(dc: DrawingContext):number {
		return 16;
	}

	protected drawBackground(dc: DrawingContext, area: Rect) {
		// dc.ctx.fillStyle = "#F0F0FF"
		// dc.ctx.fillRect(area.x, area.y, area.width, area.height);
	}


	protected drawBorder(dc: DrawingContext, area: Rect) {
		dc.ctx.strokeStyle = dc.style.getPropertyValue("--cal-header-separ");
		dc.ctx.beginPath();
		dc.ctx.moveTo(this.width - 0.5, this.y);
		dc.ctx.lineTo(this.width - 0.5, this.height);
		dc.ctx.stroke();
	}
}